module.exports = __webpack_public_path__ + "img/150ne.7ac85c37.svg";